<div class="content-panel many-inputs">
    <div class="header" trans>Project Settings</div>

    <div class="input-container">
        <div class="fake-label" trans>Template</div>
        <div class="box">
            <div class="fake-input" (click)="openTemplatesPanel()">
                <span *ngIf="activeProject.activeTemplate">{{activeProject.activeTemplate.name}}</span>
                <span *ngIf="!activeProject.activeTemplate" trans>None</span>
            </div>

            <button mat-raised-button color="accent" (click)="openTemplatesPanel()" trans>Change</button>
        </div>
    </div>

    <div class="input-container" *ngIf="!activeProject.activeTemplate">
        <div class="fake-label" trans>Theme</div>
        <div class="box">
            <div class="fake-input" (click)="openThemesPanel()">{{activeProject.get()?.model?.theme || 'None'}}</div>
            <button mat-raised-button color="accent" (click)="openThemesPanel()" trans>Change</button>
        </div>
    </div>
</div>

<div class="content-panel many-inputs">
    <div class="header" trans>Builder Settings</div>

    <div class="setting-container">
        <mat-slide-toggle color="accent" [(ngModel)]="settings.autoSave" (ngModelChange)="updateSettings()" trans>Auto Save</mat-slide-toggle>
        <p trans>Toggle auto saving of project when changes are made in the builder.</p>
    </div>

    <div class="setting-container">
        <mat-slide-toggle color="accent" [(ngModel)]="settings.hoverBoxEnabled" (ngModelChange)="updateSettings()" trans>Hover Box</mat-slide-toggle>
        <p trans>Toggle visibility of box that appears when hovering over elements in the builder.</p>
    </div>

    <div class="setting-container">
        <mat-slide-toggle color="accent" [(ngModel)]="settings.selectedBoxEnabled" (ngModelChange)="updateSettings()" trans>Selected Box</mat-slide-toggle>
        <p trans>Toggle visibility of box that appears when clicking on element in the builder.</p>
    </div>
</div>
